module.exports = __webpack_public_path__ + "img/LockbasedBST.e89e37cf.png";